import { styled } from '@mui/material/styles';

export const ErrorContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.default, // Use theme-based colors
}));

export const ErrorOps = styled('h1')(({ theme }) => ({
  fontSize: '40px',
  lineHeight: '50px',
  fontWeight: 600,
  margin: '0 0 24px',
  color: theme.palette.text.primary,
}));

export const ErrorDesc = styled('h3')(({ theme }) => ({
  fontSize: '20px',
  lineHeight: '24px',
  fontWeight: 400,
  margin: '12px 0 0 0',
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
